var _path, _circle, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo192(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "960 589 386.55 386.935",
    width: "386.55pt",
    height: "386.935pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "_rgradient_0",
    fx: 0.5,
    fy: 0.5,
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(386.55,0,0,386.935,960,589)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(135,98,196)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(191,92,153)"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 1346.55 685.541 L 1344.994 946.114 C 1344.895 962.672 1331.372 976.034 1314.815 975.935 L 989.821 973.994 C 973.264 973.895 959.902 960.372 960.001 943.815 L 961.942 618.821 C 962.041 602.264 975.563 588.902 992.12 589.001 L 1251.695 590.551 L 1346.55 685.541 Z ",
    fill: "url(#_rgradient_0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 1153.5926589825967,
    cy: 782.4676589825966,
    r: 112.375,
    fill: "rgb(247,246,241)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 1267.968 703.968 L 1345.968 780.968 L 1346.55 685.541 L 1283.968 684.968 L 1267.968 703.968 Z ",
    fill: "rgb(98,56,82)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: " M 1091.968 746.968 L 1153.968 780.968 L 1261.968 672.968 L 1294.968 672.968 L 1153.968 835.968 L 1095.968 769.968 Q 1091.968 763.968 1091.968 757.968 Q 1091.968 749.248 1091.968 746.968 Z ",
    fill: "rgb(0,0,0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: " M 1251.695 590.551 L 1251.968 684.968 L 1346.55 685.541 L 1251.695 590.551 Z ",
    fill: "rgb(9,109,217)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo192);
export default __webpack_public_path__ + "static/media/logo192.8397e216fe421ad65a9cca9e2fc88dbf.svg";
export { ForwardRef as ReactComponent };